import React from 'react';
import Link from 'next/link';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { CountryCodes } from 'src/common/enums';
import { useCountry } from 'src/common/hooks';
import { ROUTES } from 'src/common/routes';

const label = (
  <FormattedMessage
    id="signup.terms.link"
    defaultMessage="{url} Terms of Service and Privacy Policy"
    values={{ url: 'Glints' }}
    tagName="span"
  />
);

const TOSLink = ({ style }) => {
  const country = useCountry();
  if (country === CountryCodes.TW) {
    return (
      <a style={style} target="_blank" href={`/sg/${ROUTES.terms}`}>
        {label}
      </a>
    );
  } else {
    return (
      <Link href={`/${ROUTES.terms}`} style={style} target="_blank">
        {label}
      </Link>
    );
  }
};

TOSLink.propTypes = {
  style: PropTypes.object,
};

export default TOSLink;
